import { action, makeObservable, observable, runInAction, computed } from "mobx";
import firebaseAgent from "../api/firebaseagent";
import { Category } from "../models/category";
import { BaseStore } from "./baseStore";
import { collection, query } from "firebase/firestore";
import { db } from "../../firestore-config";
import { RootStore } from "./rootStore";

export default class ParentCategoryStore extends BaseStore<Category> {
    // Standard reload state matching product store style
    // categoryreload = true;
    // parentcategoryreload = true;
    
    // Internal observable for selected parent
    // parentcategory: Category = new Category();

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            // categoryreload: observable,
            // parentcategoryreload: observable,
            // parentcategory: observable,
            // setCategoryReload: action,
            // setParentCategoryReload: action,
            // setParentCategory: action,
            // setParentCategoryByCategory: action,
            // categoryByName: computed,
            // parentCategoryByName: computed
        });
    }

    // Link this store to the specific service in firebaseAgent
    protected getService() {
        return firebaseAgent.categoryService;
    }

    // --- Aliases for compatibility ---
    get category() { return this.selectedItem || new Category(); }
    set category(val: Category) { this.selectedItem = val; }
    get categories() { return this.items.filter(i => i.parentId === this.selectedItem?.id); }
    
    // // --- CRUD Actions ---
    // loadCategoryList = async () => {
    //     await this.loadAll();
    // }

    // loadCategory = async (id: string) => {
    //     return this.getItem(id);
    // }

    // --- Unique Category Logic ---
    loadCategoryListByID = async (categoryParentID: string) => {
        if (!this.isLoaded) await this.loadParentCategoryList();
        return this.items.filter(c => c.parentID === categoryParentID);
    }

    resetSelectedItem = ()=>{
        this.selectedItem = null;
    }

    loadParentCategoryList = async () => {
        try {
            return await this.items.filter(c => (c.parentID === undefined || c.parentID === null));
        } catch (error) {
            console.error("Failed to load parent child categories", error);
            throw error;
        }
    }

    // // --- State Setters ---
    // setCategoryReload = (state: boolean) => {
    //     runInAction(() => {
    //         this.categoryreload = state;
    //     });
    // }

    // setParentCategoryReload = (state: boolean) => {
    //     runInAction(() => {
    //         this.parentcategoryreload = state;
    //     });
    // }

    // setParentCategory = (id: string) => {
    //     const found = this.items.find(c => c.id === id);
    //     if (found) {
    //         runInAction(() => {
    //             this.parentcategory = found;
    //         });
    //     }
    // }

    // setParentCategoryByCategory = (parentCategory: Category) => {
    //     runInAction(() => {
    //         this.parentcategory = parentCategory;
    //     });
    // }

    // --- Computed Properties (Sorting & Filtering) ---
    get categoryByName() {
        return [...this.items].sort((a, b) => {
            // 1. Sort by displayOrder (Ascending)
            // Use 0 or a high number as default if displayOrder is missing
            const orderA = a.displayOrder ?? 999; 
            const orderB = b.displayOrder ?? 999;

            if (orderA !== orderB) {
                return orderA - orderB;
            }

            // 2. If displayOrder is the same, fallback to alphabetical name sort
            return (a.name || "").localeCompare(b.name || "");
        });
        // return [...this.items].sort((a, b) => 
        //     (a.name || "").localeCompare(b.name || "")
        // );
    }

    // get parentCategoryByName() {
    //     return this.items
    //         .filter(c => !c.parentCategory || c.parentCategory === "")
    //         .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    // }
}